import {useEffect} from 'react';

import {useSelector} from '../state/hooks';
import {useViewer} from '../state/viewer/hooks';
import {getViewerLoading} from '../state/viewer/selectors';
import {initDatadog} from './datadog/datadog';
import {startPerfObserver} from './datadog/perfObserver/performanceObserver';

export const useConsentAwareAnalyticsInjection = () => {
  const viewerIsLoading = useSelector(getViewerLoading);
  const viewer = useViewer();

  useEffect(() => {
    if (viewerIsLoading) {
      return;
    }

    const injector = (window as any).WBAnalyticsInjector;
    if (injector) {
      const authenticated = !!viewer?.username;
      try {
        injector.initializeTrackingScripts(authenticated);
        initDatadog();
      } catch (e) {
        // console.error('Failed to inject analytics', e);
        return;
      }

      // Keep this outside the try/catch so dev-only contract validation errors remain visible.
      startPerfObserver();
    }
  }, [viewer, viewerIsLoading]);
};
